// src/views/ErrorView.js

import React from 'react';
import Error404Template from '../templates/error/Error404Template';

function ErrorView() {
    return (
        <Error404Template />
    );
}

export default ErrorView;
